<template>
  <div class="item-wrapper">
  <item-wrapper :params="params" :data="data" idField="designerPageId" ref="wrapper"></item-wrapper>
  </div>
</template>

<script>
    export default {
        name: "item-wrapper-designer",
        props:["data","params"],

      mounted() {
          let me=this;
          let p=this.params;
          if(p.type==="page"){
            let innerPage=me.$refs.wrapper.$refs.innerPage;
            let unwatch=innerPage.$watch("pageReady",r=>{
              innerPage.$refs.pageObj.$on("addItems",(items,el)=>{
                me.$emit("addItems",items,el);
              });
              unwatch()
            })
          }else if(p.type==="comp"){
            if(_.isFunction(p.dataProcess)){
              p.dataProcess(p);
            }
          }
      },
      methods:{
        setContainerData(ct,items,data){
          if(this.params.type==="page"){
            let pageObj=this.$refs.wrapper.$refs.innerPage.$refs.pageObj
            if (pageObj && pageObj.setContainerData) {
              pageObj.setContainerData(ct,items,data)
            }
          }
        }
      }
    }
</script>

<style scoped>
.item-wrapper{
  border:1px solid #ccc;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/designer/item-wrapper-designer.vue